// extracted by mini-css-extract-plugin
module.exports = {"container":"CookieBanner_container__TBJ3k","content":"CookieBanner_content__1itsm"};